import React from 'react'
import { useEffect } from 'react';
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Breadcrumbs from '../../components/Breadcrumbs';

function Sustainability() {
  const page = "sustainability";
  useEffect(() => {
    // ensure Swiper script is loaded (from CDN in index.html <head>)
    if (!window.Swiper) return;
    const swiper = new window.Swiper('.materials-carousel', {
      speed: 500,
      spaceBetween: 28,
      slidesPerView: 3,
      slidesPerGroup: 1,
      grabCursor: true,
      keyboard: { enabled: true },
      navigation: {
        nextEl: '.materials-carousel .swiper-button-next',
        prevEl: '.materials-carousel .swiper-button-prev',
      },
      pagination: {
        el: '.materials-carousel .swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0:    { slidesPerView: 1 },
        640:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });

    return () => swiper?.destroy(true, true);
  }, []);  
  return (
    <div>
      {/* <Header /> */}
        <section className={`hero ${page}`}>
          <h1>Sustainability</h1>
        </section>

        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "About", to: "/about" },
                { label: "Sustainability" }, // no `to` = current page
        ]}
        />


        <section className="about-section">
          <div className="fullscreen-kicker">
            <h1>Sustainability at DMCO</h1>
          </div>
          <div className="container">
            <p>
              At DMCO, sustainability is not just an initiative—it is a core part of our business strategy. As a leading manufacturer of drilling materials in Saudi Arabia, we recognize our responsibility to balance industrial growth with environmental stewardship, safety, and community well-being.
            </p>
          </div>
        </section>

        <section className="industory-section" id="industory">
          <div className="container">

            {/* Section 1: Heading */}
            <div className="industory-heading">
              <div className="industory-kicker" aria-hidden="true">Our Commitment</div>
            </div>
            {/* Section 2: Grid */}
            <div className="industory-grid">

              {/* Card 1 */}
              <span className="industory-card">
                <a href="#">
                  <div className="description">
                    We actively reduce our environmental footprint through energy-efficient production, waste reduction programs, and water conservation measures. Our facilities are aligned with Saudi Arabia's <strong>Vision 2030 sustainability goals</strong> and global ESG benchmarks.
                  </div>
                </a>
                <div className="card-footer">
                  <div className="title">Environmental Responsibility</div>
                </div>        
              </span>
              


              {/* Card 2 */}
              <span className="industory-card">
                <a href="#">
                  <div className="description">
                    Health, Safety, and Environment (HSE) standards form the backbone of our operations. We ensure compliance with <strong>Aramco standards, ISO 14001, and ISO 45001</strong>, while maintaining strict safety protocols for our workforce and partners.
                  </div>
                </a>
                <div className="card-footer">
                  <div className="title">Safety & Compliance</div>
                </div>
              </span>

              {/* Card 3 */}
              <span className="industory-card">
                <a href="#">
                  <div className="description">
                    By investing in <strong>cutting-edge technologies and digital solutions</strong>, we enhance operational efficiency and minimize emissions. Our R&D team continuously explores alternative materials and processes to support a greener supply chain.
                  </div>
                </a>
                <div className="card-footer">
                  <div className="title">Innovation for Sustainability</div>
                </div>        
              </span>
            </div>

          </div>
        </section>

        <section className="about-section">
          <div className="fullscreen-kicker">
            <h1>Measuring Impact</h1>
          </div>
          <div className="container">
            <p>
              We continuously monitor and report on our sustainability performance, ensuring transparency and accountability for stakeholders. Our KPIs focus on:
            </p>
            <ul className="kpi-list">
              <li>Carbon footprint reduction.</li>
              <li>Waste recycling and recovery rates.</li>
              <li>Energy and water efficiency.</li>
              <li>Community engagement and workforce safety.</li>
            </ul>        
          </div>
        </section>

        <section className="materials-section" id="materials">
          <div className="container">
            <div className="materials-heading">
              <div className="materials-kicker" aria-hidden="true">Key Initiatives</div>
            </div>

            {/* CAROUSEL */}
            <div className="materials-carousel swiper">
              <div className="swiper-wrapper">

                {/* Slide (repeat for each product) */}
                <div className="swiper-slide">
                  {/*a href="../project/pages/industry-detail.html"*/}
                    <article className="material-card">
                      <div className="thumb">
                        <img src="/assets/images/icons/energy-efficient.png" alt="Energy Efficient" />
                      </div>
                      {/* <h3 className="title">Oil and Gas</h3> */}
                      <p className="description">
                        Transitioning to <strong>energy-efficient machinery</strong> and renewable energy sources in production.
                      </p>
                    </article>
                  {/* </a> */}
                </div>

                <div className="swiper-slide">
                  {/* <a href="pages/industry-detail.html"> */}
                    <article className="material-card">
                      <div className="thumb">
                        <img src="/assets/images/icons/circular-economy.png" alt="Circular Economy" />
                      </div>
                      {/* <h3 className="title">Water Well</h3> */}
                      <p className="description">
                        Implementing <strong>circular economy practices</strong>, including recycling and reuse of raw materials.
                      </p>
                    </article>
                  {/* </a> */}
                </div>

                <div className="swiper-slide">
                  {/* <a href="pages/industry-detail.html"> */}
                    <article className="material-card">
                      <div className="thumb">
                        <img src="/assets/images/icons/esg-values.png" alt="ESG Values" />
                      </div>              
                      {/* <h3 className="title">Automotive</h3> */}
                      <p className="description">
                        Partnering with suppliers who share our <strong>ESG values</strong>.
                      </p>
                    </article>
                  {/* </a> */}
                </div>

                <div className="swiper-slide">
                  {/* <a href="pages/industry-detail.html"> */}
                    <article className="material-card">
                      <div className="thumb">
                        <img src="/assets/images/icons/eco-friendly.png" alt="ECO Friendly" />
                      </div>
                      {/* <h3 className="title">Civil Sector</h3> */}
                      <p className="description">
                        Introducing <strong>eco-friendly packaging and logistics solutions</strong>.
                      </p>
                    </article>
                  {/* </a> */}
                </div>
              </div>

              {/* Controls */}
              <div className="swiper-button-prev" aria-label="Previous"></div>
              <div className="swiper-button-next" aria-label="Next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </section>

        <section className="about-section">
          <div className="fullscreen-kicker">
            <h1>Our Pledge</h1>
          </div>
          <div className="container">
            <p>
              DMCO is committed to driving <strong>responsible growth</strong> while supporting the Kingdom’s transformation towards a sustainable future. Together with our partners and customers, we aim to deliver <strong>long-term value</strong>  that benefits not only the industry, but also the environment and society at large.
            </p>
          </div>
        </section>
      {/* <Footer /> */}
    </div>
  )
}

export default Sustainability